import SectionTitle from '@/components/base/SectionTitle';
import { principles } from '@/mocks/site';

export default function PrinciplesSection() {
  return (
    <section id="principles" className="w-full border-b border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-6">
          <SectionTitle
            eyebrow="Our Standard"
            title="我们不承诺永远正确，但承诺方法透明"
            desc="求证的意义不在于给出一个绝对答案，而在于让判断过程可以被看见、被复核、被修正。"
          />

          <div className="mt-8 space-y-6">
            {principles.map((item) => (
              <div key={item.title} className="flex gap-4">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-background-50 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative">
            <div className="h-72 w-full overflow-hidden rounded-2xl border border-background-200 sm:h-80 md:h-[26rem]">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20a%20balance%20scale%20and%20stacked%20documents%20on%20warm%20cream%20background%2C%20muted%20amber%20and%20deep%20jade%20green%20geometric%20shapes%2C%20minimal%20flat%20vector%20style%2C%20calm%20balanced%20composition%2C%20no%20text&width=900&height=1100&seq=gt-principles&orientation=portrait"
                alt="以暖色几何图形表现证据衡量的插画"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-4 w-60 rounded-xl border border-background-200 bg-background-50 p-4">
              <p className="font-heading text-sm font-semibold text-foreground-950">结论可追溯率</p>
              <div className="mt-3 flex items-center gap-3">
                <span className="font-heading text-2xl font-black text-accent-600">96.2%</span>
                <span className="h-2 flex-1 overflow-hidden rounded-full bg-background-200">
                  <span className="block h-full w-[96%] rounded-full bg-accent-500"></span>
                </span>
              </div>
              <p className="mt-2 text-xs text-foreground-600">每条结论均附来源与更新时间</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}